import { render, staticRenderFns } from "./PlayerLink.vue?vue&type=template&id=6b36cb4a&"
import script from "./PlayerLink.vue?vue&type=script&lang=js&"
export * from "./PlayerLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports